<div class="my-5">
    <h3 class="text-center m-5">Receipt Page</h3>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <p>Your Application and Payment has been submitted and received. Thank you.</p>
                    <ng-container *ngIf="web_filing_id !== ''">
                        <p><b>Filing Reference ID:</b> {{web_filing_id}}</p>
                    </ng-container>
                    <ng-container *ngIf="nbr !== ''">
                        <p><b>Payment Reference Number:</b> {{nbr}}</p>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>